import { getValueFromContent } from './getValueFromContent';

export function parsePiHeaderSlotItem(item, { isOmitted, content }) {
  if (isOmitted(item)) {
    return null;
  }

  if (item.data.label) {
    item.data.label = getValueFromContent(item.data.label, content);
  }

  if (item.data.link) {
    item.data.link = {
      url: getValueFromContent(item.data.link.url, content),
      target: item.data.link.target,
    };
  }

  if (item.data.items) {
    item.data.items = item.data.items.map((childItem) => {
      Object.entries(childItem).reduce((acc, [k, v]) => {
        acc[k] = getValueFromContent(v, content);
        return acc;
      }, childItem);
      return childItem;
    });
  }

  if (item.children) {
    item.children = item.children.map((x) => parsePiHeaderSlotItem(x, { isOmitted, content })).filter((x) => x);
  }

  return item;
}
